import React from 'react'
import { Helmet } from 'react-helmet'
import utils from '../../utils'

function RequestViewPage(props) {
    const url = window.location.href
    return (
        <div>
            <Helmet>
                <title>Nurse Request View - {utils.siteName}</title>
                <link rel="canonical" href={url} />
                <meta 
                    property="description" 
                    content=""/>
            </Helmet>
            
            
        </div>
    )
}

export default RequestViewPage